import { html, LitElement, nothing, TemplateResult } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { styles } from '../view/styles';
import { WidgetStateFrontEnd } from '../../../genericDashboard/gzGenericWidget/types';
import { WidgetSectionItemSeverity } from '../types';
import { isEmpty } from '@nirvana/shared/basic-types/object';
import { ifDefined } from 'lit/directives/if-defined.js';

@customElement('gz-widget-section-item')
export class GzWidgetSectionItemWebComponent extends LitElement {
  @property({ type: String, attribute: true, reflect: true })
  name: string;

  @property({ type: Number, attribute: true, reflect: true })
  value: number;

  @property({ type: WidgetSectionItemSeverity, attribute: true, reflect: true })
  severity?: WidgetSectionItemSeverity;

  @property({ type: Number, attribute: true, reflect: true })
  progressMaxValue?: number;

  @property({ type: Number, attribute: true, reflect: true })
  progressValue?: number;

  @property({ type: String, attribute: true, reflect: true })
  progressColor?: string;

  @property({ type: String, attribute: true, reflect: true })
  itemTooltipText?: string;

  @property({ type: WidgetStateFrontEnd, attribute: true, reflect: true })
  state: WidgetStateFrontEnd;

  private emptyStateColor = '#b3b3b3';

  static get styles() {
    return styles;
  }

  render(): TemplateResult {
    const itemName =
      this.state === WidgetStateFrontEnd.IS_ERROR ||
      this.state === WidgetStateFrontEnd.IS_INFO ||
      this.state === WidgetStateFrontEnd.IS_CHANGED
        ? '...'
        : this.name;
    const displayValue = this.state === WidgetStateFrontEnd.IS_ACTIVE ? this.value : '_';
    return html`
      <div class="row fs-12">
        <div class="item-info">
          <gz-tooltip class="label-tooltip" isEllipsis tooltipText="${itemName}">
            <div class="item-name">${itemName}</div>
          </gz-tooltip>
          <gz-tooltip
            class="wrapper-tooltip ${this.isProgressBarEmpty() ? 'no-progress-bar' : ''}"
            tooltipText="${this.state !== WidgetStateFrontEnd.IS_INFO ? ifDefined(this.itemTooltipText) : nothing}"
          >
            ${this.renderProgressBar()}
            <div class="item-severity">
              <div class="item-value">${displayValue}</div>
              ${this.renderIcon()}
            </div>
          </gz-tooltip>
        </div>
      </div>
    `;
  }

  private isProgressBarEmpty(): boolean {
    return isEmpty(this.progressValue && this.progressColor && this.progressMaxValue);
  }

  private renderProgressBar(): TemplateResult | undefined {
    if (this.isProgressBarEmpty()) {
      return;
    }
    const value = this.state !== WidgetStateFrontEnd.IS_ACTIVE ? 0 : this.progressValue;
    const maxValue = this.state !== WidgetStateFrontEnd.IS_ACTIVE ? 0 : this.progressMaxValue;
    const progressColor: string | undefined =
      this.state !== WidgetStateFrontEnd.IS_ACTIVE ? this.emptyStateColor : this.progressColor;
    return html`<gz-progress .valueNow="${value}" .valueMax=${maxValue} .progressColor="${progressColor}" />`;
  }

  private renderIcon(): TemplateResult | undefined {
    if (!this.severity) {
      return;
    }
    const severity = this.severity === WidgetSectionItemSeverity.ERROR ? 'negative' : this.severity;
    const color = severity === 'negative' ? 'var(--red-layout-300-primary)' : severity;
    return severity && this.state === WidgetStateFrontEnd.IS_ACTIVE && severity !== WidgetSectionItemSeverity.EMPTY
      ? html`<gz-icon size="14" name="ds-icon-notification_${severity}" color="${color}"></gz-icon>`
      : html`<span class="item-icon circle-icon gray-color" />`;
  }
}
